<template>
    <app-sercheable-data-table :headers="headers" :search="search" :refresh="refresh" :pagination="pagination">
        <template slot="afterReloadButton" v-if="!readonly">
            <v-btn :to="{ name: 'officeCreate' }" color="primary">{{ $t('label.createOffice') }}</v-btn>
        </template>
        <template slot="items" slot-scope="{item}">
            <router-link :to="{ name: 'officeEdit', params: { id: item.id }}" tag="tr">
                <td>{{ item.id }}</td>
                <td>{{ item.acronym }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.email }}</td>
            </router-link>
        </template>
    </app-sercheable-data-table>
</template>

<script>
import utilities from '@/helpers/utilities';
import SercheableDataTable from '../shared/SercheableDataTable';

export default {
    data() {
        return {
            pagination: {
                descending: false,
                sortBy: 'name',
            },
            headers: [
                {
                    text: this.$t('label.code'),
                    value: 'id',
                    align: 'left',
                },
                {
                    text: this.$t('label.office'),
                    value: 'acronym',
                    align: 'left',
                },
                {
                    text: this.$t('label.name'),
                    value: 'name',
                    align: 'left',
                },
                {
                    text: this.$t('label.status'),
                    value: 'status',
                    align: 'left',
                },
                {
                    text: this.$t('label.email'),
                    value: 'status',
                    align: 'left',
                },
            ],
        };
    },
    methods: {
        search(filters) {
            const offices = this.$store.getters.offices;

            return utilities.filterMultiple(offices, filters, (office, regex) => (
                regex.test(office.acronym) ||
                regex.test(office.name) ||
                regex.test(office.id)
            ));
        },
        async refresh() {
            await this.$store.dispatch('loadOffices');
        },
    },
    computed: {
        offices() {
            const items = this.$store.getters.offices;
            items.forEach((item) => { item.status = item.isActive ? this.$t('label.active') : this.$t('label.inactive'); });
            return items;
        },
        readonly() {
            return !this.$store.getters.isAdmin;
        },
    },
    components: {
        appSercheableDataTable: SercheableDataTable,
    },
};
</script>




// WEBPACK FOOTER //
// src/components/offices/Index.vue